import React, { useEffect } from 'react';
import Slider from 'react-slick';
import { imagePrefix } from '../../../../public/constants/constants';
import "../../../../public/styles/blog/handPicked.scss";
import HandlePickedSliderItem from './handlePickedSliderItem';


function HandPicked(props) {

  useEffect(() => {
    console.log(props, props.productCount, 'propsssss');
  }, [props]);

  const leftArrow = "/B2C/EspotImages/Images/rcb/arrows/arowLeft1.png";
  const rightArrow = "/B2C/EspotImages/Images/rcb/arrows/arrowRight1.png";

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: false,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          dots: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
        },
      },
    ],
    nextArrow: <div className='next'><img src={imagePrefix + rightArrow} alt="next"></img> </div>,
    prevArrow: <div className='next'> <img src={imagePrefix + leftArrow} alt="Prev"></img> </div>,
  };

  return (
    <div className="hand-picked">
      <div className="hand-picked-title">Handpicked for you</div>
      <div className="carousel-inner"><Slider {...settings}>
        {props && Array.isArray(props.productPartNumbers) && props.productPartNumbers.map((partNumber, index) => (
            <HandlePickedSliderItem index={index} productPartNumber={partNumber} />
        ))}
      </Slider>
      </div>
    </div>
  )
}

export default HandPicked
